import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import { Dropdown, Button, Icon } from '@softwaredev_cegeka/stix-core'

import ImpersonateMenu from './ImpersonateMenu'
import withUserData from 'src/components/auth/withUserData'

import styles from './userMenu.module.scss'

const AvatarButton = React.forwardRef((props, ref) => {
    const { userData, ...rest } = props
    const { firstName, lastName } = userData.data
    return (
        <Button {...rest}>
            <div className={styles.userDataWrapper} ref={ref}>
                <span className={styles.userFirstLastName}>
                    {firstName} {lastName}
                </span>
                {userData.impersonatedOrganization ? (
                    <span className={styles.impersonatedTenant}>
                        {userData.impersonatedOrganization.label}
                    </span>
                ) : null}
            </div>
            <Icon icon={'user-outline'} />
            <Icon className={'chevron-down'} icon={'chevron-down'} />
        </Button>
    )
})

class UserMenu extends Component {
    render() {
        const { userData } = this.props
        return (
            <Dropdown className={styles.loginMenu} alignRight>
                <Dropdown.Toggle
                    as={AvatarButton}
                    id="user-dropdown-menu"
                    userData={userData}
                />
                <Dropdown.Menu className={styles.loginDropdown}>
                    <ImpersonateMenu />
                    <Dropdown.Divider />
                    <Link className={'stix-dropdown-item'} to="/logout">
                        Logout
                    </Link>
                </Dropdown.Menu>
            </Dropdown>
        )
    }
}

export default withUserData(UserMenu)
